module.exports = __webpack_public_path__ + "static/media/logo-meta.8102ca8f.webp";